import React from "react";
import { format, parseISO } from "date-fns";

// Componente actualizado para usar props en lugar del contexto
const ConfirmationStep = ({ selectedWorkOrder, selectedTrip }) => {
  // Helper function to format dates safely
  const formatDateSafely = (dateValue) => {
    if (!dateValue) return "Not available";

    try {
      // Handle both Date objects and ISO strings
      const date =
        typeof dateValue === "string" ? parseISO(dateValue) : dateValue;
      return format(date, "MMM d, yyyy");
    } catch (error) {
      return "Invalid date";
    }
  };

  return (
    <div className="p-4">
      <h5 className="mb-4">Confirm Details</h5>
      {selectedWorkOrder && selectedTrip && (
        <div>
          <div className="card mb-3">
            <div className="card-header bg-light">
              <strong>Work Order Information</strong>
            </div>
            <div className="card-body">
              <p>
                <strong>Job No:</strong> {selectedWorkOrder.jobNo}
              </p>
              <p>
                <strong>Customer:</strong> {selectedWorkOrder.customer.name}
              </p>
              <p>
                <strong>Location:</strong> {selectedWorkOrder.location.city},{" "}
                {selectedWorkOrder.location.state}
              </p>
            </div>
          </div>

          <div className="card mb-3">
            <div className="card-header bg-light">
              <strong>Trip Information</strong>
            </div>
            <div className="card-body">
              <p>
                <strong>Trip Number:</strong> {selectedTrip.tripNumber}
              </p>
              <p>
                <strong>Selected Date:</strong>{" "}
                {formatDateSafely(selectedTrip.selectedDate)}
              </p>
              <p>
                <strong>Trip Period:</strong>{" "}
                {formatDateSafely(selectedTrip.startDate)} -{" "}
                {formatDateSafely(selectedTrip.endDate)}
              </p>
            </div>
          </div>

          {selectedTrip.selectedTechnician && (
            <div className="card">
              <div className="card-header bg-light">
                <strong>Technician Information</strong>
              </div>
              <div className="card-body">
                <p>
                  <strong>Name:</strong> {selectedTrip.selectedTechnician.name}
                </p>
                {selectedTrip.selectedTechnician.email && (
                  <p>
                    <strong>Email:</strong>{" "}
                    {selectedTrip.selectedTechnician.email}
                  </p>
                )}
                {selectedTrip.selectedTechnician.isLead && (
                  <p>
                    <strong>Role:</strong>{" "}
                    <span className="badge bg-success text-white">
                      Lead Technician
                    </span>
                  </p>
                )}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ConfirmationStep;
